<template>
   <div class="filter-wrapper clearfix">
      <div class="capability-filter-wrapper">
         <div class="capability-filter" :style="{visibility: data_ready && capabilities_ready? 'visible' : 'hidden'}">
            <div class="label">Capabilities Filter</div>            
            <div class="capability-filter-options">
               <div v-for="(item, key) in capabilities" :key="key"><span v-if="item.count > 0" v-on:click="toggle_selected_services(key)" :class="get_service_classes(key.toLowerCase())">{{key}}</span></div>
            </div>
            <div class="filter-reset" v-on:click="reset_selected_services()"><span class="reset-filter">Clear Filter</span></div>
            <!--
            <label>Filter by UMM Services</label>
            <ul>
               <li :class="get_service_classes(term)" v-for="(term, index) in umm_s.items" :key="index" v-on:click="toggle_selected_services(term['meta']['concept-id'])" v-html="umm_services_name(term)" :title="term['umm']['LongName']"></li>
            </ul>
            -->
         </div>
         <div class="advance-filters">
            <input type="text" name="search" class="form-control" placeholder="Filter by Text" v-model="title_filter" :disabled="data_ready == false" :style="{backgroundColor: data_ready && capabilities_ready ? 'white' : 'gray'}">
         </div>
      </div>

      <div class="panel-wrapper">
         <div class="record-count"><span v-if="data_ready">Found {{filtered_item_count}} matching dataset(s)</span><span v-else><i class="fas fa-sync fa-spin"></i> Loading datasets</span></div>
         <div class="switch-panel" v-if="data_ready">
            <ul>
               <li :class="switch_mode_class('list')" v-on:click="switch_mode('list')">LIST</li>
               <li :class="switch_mode_class('table')" v-on:click="switch_mode('table')">TABLE</li>
            </ul>
         </div>
      </div>
   </div>
</template>

<script>
import {mapState,mapMutations} from "vuex";
import datasets_processing from './mixins/datasets_processing';

export default {
   name: "DatatableFilters",
   data () {
      return {
         title_filter: ''
      }
   },
   computed: {
      ...mapState([
         "cloud_datasets",
         "service_terms",
         "selected_services",
         "capabilities",
         "capabilities_ready",
         "umm_s",
         "item_counts",
         "filtered_item_count",
         "data_ready",
         "display_mode"
      ]),
   },
   mixins: [datasets_processing],
   methods: {
      ...mapMutations([
         'UPDATE_SELECTED_SERVICES',
         'RESET_SELECTED_SERVICES'
       ]),
      switch_mode: function(mode) {
         this.$emit("switch", mode);
      },
      switch_mode_class: function(mode) {
         let classes = [];
         classes.push(mode);
         if(this.display_mode == mode) classes.push('active');
         return classes;
      },
      get_service_classes: function(service) {
         let classes = ['filter-icon','icon-' + service];
         //console.log(this.selected_services);
         if(this.selected_services.includes(service)) classes.push('selected');
         return classes;
      },
      toggle_selected_services: function(service) {
         this.UPDATE_SELECTED_SERVICES(service.toLowerCase());
      },
      reset_selected_services: function() {
         this.RESET_SELECTED_SERVICES();
      },
      umm_services_name: function(service) {
         let label = service["umm"]["Type"];
         if(service["umm"]["LongName"].indexOf("Subsetter") >= 0) {
            label = "Subsetter";
         }
         return label;
      }
   },
   watch: {
      title_filter: function(newFilter) {
         this.$emit('filter_text', newFilter);
      }
   }
}
</script>